module.exports = __webpack_public_path__ + "static/media/2-copy.49d46479.svg";